/**
 * Session event contract in the browser (cross-cutting domain).
 * The HTTP adapter only fires the event; the shell listens without depending on that adapter.
 */
export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired' as const;

/** Fired after a successful in-app login so the shell can mount layout + router without reloading. */
export const SHELL_AUTH_LOGIN_SUCCESS_EVENT = 'shell:auth-login-success' as const;
